// Reconnecting only fixes a dead or missing grant, which the email-service
// answers with 412 / `{status: 'auth_error'}` (including a Nylas
// grant.not_found) - matched the same way in useStartSyncRequest. Anything
// else (401 no session, 403 not admin or broker, provider errors such as a
// missing reply target) is not reconnect-fixable.
export const isReconnectFixableSendError = (
  status: number,
  body: unknown,
): boolean =>
  status === 412 ||
  (typeof body === 'object' &&
    body != null &&
    'status' in body &&
    body.status === 'auth_error');
